import React, { ReactNode } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { attackEventFragment } from '../shared'
import { AttackStatus } from '../../attack-status'
import { DrilldownAttackEvent } from './drilldown-content-view'
import { GraphQLRemoveTypename } from '../../graphql'

export const attackEventDrilldownQuery = gql`
  query GetAttackEvent($organizationID: ID!, $attackEventID: ID!) {
    attackEvent(
      organizationID: $organizationID
      attackEventID: $attackEventID
    ) {
      ...AttackEvent
      hidden
      callLocation
      httpRequest {
        method
        queryString
        uri
        version
        body
        headers
        parameters
        valid
      }
      file
      method
      line
      stackFrames {
        type
        description
        fileName
        lineNumber
        className
        methodName
        stackIndex
        shortSummary
      }
      lastCustomFrame
      signature
      vector
      tags
      detectionType
      application {
        language
      }
      userInput {
        name
        type
      }
      storyChapters {
        type
        introTemplate
        introVariables
        bodyTemplate
        bodyVariables
      }
      requestChapters {
        type
        introText
        body
      }
    }
  }

  ${attackEventFragment}
`

export function DrilldownQuery({
  organizationID,
  attackEventID,
  children
}: {
  readonly organizationID: string
  readonly attackEventID: string
  readonly children: (props: {
    readonly loading: boolean
    readonly refetch: () => Promise<any>
    readonly attackEvent: DrilldownAttackEvent
  }) => ReactNode
}) {
  return (
    <Query
      query={attackEventDrilldownQuery}
      fetchPolicy="cache-first"
      variables={{
        organizationID,
        attackEventID
      }}
    >
      {({ data, loading, refetch, ...props }) => {
        if (props.error) {
          throw new Error(props.error.message)
        }
        return (
          <GraphQLRemoveTypename data={data}>
            {({ data }) => {
              const { attackEvent } = data
              return children({
                loading,
                refetch,
                attackEvent: !!attackEvent
                  ? {
                      ...attackEvent,
                      sourceName: attackEvent.sourceName
                        ? attackEvent.sourceName.name
                        : undefined,
                      result: attackEvent.result as AttackStatus,
                      storyChapters: attackEvent.storyChapters.map(
                        (chapter) => ({
                          type: chapter.type,
                          introTemplate: chapter.introTemplate
                            ? chapter.introTemplate
                            : undefined,
                          introVariables: chapter.introVariables
                            ? JSON.parse(chapter.introVariables)
                            : undefined,
                          bodyTemplate: chapter.bodyTemplate
                            ? chapter.bodyTemplate
                            : undefined,
                          bodyVariables: chapter.bodyVariables
                            ? JSON.parse(chapter.bodyVariables)
                            : undefined
                        })
                      )
                    }
                  : undefined
              })
            }}
          </GraphQLRemoveTypename>
        )
      }}
    </Query>
  )
}
